export default __webpack_public_path__ + "3147fd13cb51b51ce524529df3244761.jpg";